<script>
  import QuestionFrame from './QuestionFrame.svelte';
</script>

<QuestionFrame>
  <p>Bestehen die Beschwerden seit mehr als 3 Monaten?</p>
  <p class="italic">
    Hinweis: Es können beschwerdefreie Phasen bestehen, die Stärke kann variieren oder sie sind
    anhaltend fast gleich stark.
  </p>
</QuestionFrame>
